// extracted by mini-css-extract-plugin
export default {"box":"SelectBankAccount_box__BGpCE","selected":"SelectBankAccount_selected__wu21e","check":"SelectBankAccount_check__B8yHa"};